import React from "react";

/**
 * Pure-CSS confetti burst — 24 colored squares animated upward+outward+rotating.
 * No external lib. ~1.2 KB JS overhead.
 */
export default function ConfettiBurst() {
  const colors = ["#134E34", "#C8795A", "#E0B043", "#8a6a14", "#0f3d29"];
  const pieces = Array.from({ length: 24 }, (_, i) => ({
    id: i,
    left: 50 + (Math.random() - 0.5) * 12,
    dx: (Math.random() - 0.5) * 320,
    dy: -200 - Math.random() * 160,
    rot: (Math.random() - 0.5) * 720,
    color: colors[i % colors.length],
    delay: Math.random() * 80,
  }));
  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden" data-testid="confetti-burst">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="absolute block w-2 h-3 rounded-sm animate-confetti"
          style={{
            left: `${p.left}%`,
            top: "60%",
            background: p.color,
            "--dx": `${p.dx}px`,
            "--dy": `${p.dy}px`,
            "--rot": `${p.rot}deg`,
            animationDelay: `${p.delay}ms`,
          }}
        />
      ))}
    </div>
  );
}
